import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SWOffering from "@/pages/SWOffering";

export const Route = createFileRoute("/es/servicios/software-solutions-services/cualificacion-de-la-infraestructura-informatica")({
  head: () => buildRouteHead("/es/servicios/software-solutions-services/cualificacion-de-la-infraestructura-informatica"),
  component: SWOffering,
});

